exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.number_area {\n  text-align: left;\n}\n.number_list {\n  list-style: none;\n  width: -moz-fit-content; /* Firefox */\n  width: fit-content; /* Firefox以外 */\n  margin-left: auto; /* 画面によって左寄せ等ある場合はpropsで指定するように変更する */\n}\n", ""]);

// exports
